import React, { FC } from 'react'
import cx from 'classnames'
import styles from './Text.module.scss'

type TextProps = {
  size?: 'xsmall' | 'small' | 'standard' | 'large'
  weight?: 'regular' | 'medium' | 'strong'
  align?: 'left' | 'right' | 'center'
  truncate?: boolean
  component?: keyof JSX.IntrinsicElements
  className?: string
  inheritColor?: boolean
  // TODO: Research how to make this generic
  htmlFor?: string
}

export const Text: FC<TextProps> = ({
  align = 'left',
  children,
  className = '',
  component: TextComponent = 'p',
  size = 'standard',
  truncate = '',
  weight = 'regular',
  inheritColor = false,
  ...other
}) => {
  const classes = cx({
    [styles.text]: true,
    [styles.truncate]: truncate,
    [styles[align]]: align,
    [styles[weight]]: weight,
    [styles[size]]: size,
    [styles.inheritColor]: inheritColor,
    [className]: className,
  })

  return (
    <TextComponent className={classes} {...other}>
      {children}
    </TextComponent>
  )
}

Text.displayName = 'Text'
